import { Helmet } from "react-helmet";
import ContainerHeaderLayout from "views/components/ContainerHeaderLayout/ContainerHeaderLayout";
import ModelTable from "./ModelTable";
import ValidationJobsTable from "./ValidationJobsTable";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { getIsUserConfigLoading } from "redux/SingleDataset/selectors";
import { getIsModelsCatalogEnabled, getUserConfig } from "redux/User/selectors";
import { useNavigate } from "react-router";
import Loader from "views/uikit/Loader";
import UnavailableModal from "views/components/UnavillableModal/UnavailableModal";
import { Tab } from "views/components/ContainerHeader/TabSwitch";
import { GuideBook, GuideButton } from "views/components/Guide";
import { useModelCatalogGuideStore } from "views/components/Guide/guides/guideStores";
import { MODEL_CATALOG_TOPICS } from "views/components/Guide/guides/pageGuides";
import { useTabSelection, modelCatalogeTabTypes } from "./useTabSelection";

export default function ModelCatalogPage() {
  const isConfigLoading = useSelector(getIsUserConfigLoading);
  const userConfig = useSelector(getUserConfig);
  const navigate = useNavigate();
  const isModelsCatalogEnabled = useSelector(getIsModelsCatalogEnabled);
  const loading = userConfig.length === 0 || isConfigLoading;
  const { tabContent, selectedTab } = useTabSelection();
  const guideOpen = useModelCatalogGuideStore((s) => s.open);
  const openGuide = useModelCatalogGuideStore((s) => s.openGuide);
  const closeGuide = useModelCatalogGuideStore((s) => s.closeGuide);

  return (
    <>
      <Helmet>
        <title>Model Catalog</title>
      </Helmet>
      <ContainerHeaderLayout
        upperRow={
          <div className={styles.pageHeader}>
            <div className={styles.pageTitle}>
              Model Catalog
              <GuideButton
                inTitle
                tooltip="How the Model Catalog works"
                onClick={openGuide}
              />
            </div>
            <GuideBook
              open={guideOpen}
              onClose={closeGuide}
              heading="Model Catalog"
              topics={MODEL_CATALOG_TOPICS}
            />
            <div className={styles.tabsContainer}>
              {tabContent.map((tab) => (
                <Tab
                  key={tab.key}
                  label={tab.label}
                  selected={tab.selected}
                  disabled={tab.disabled}
                  onClick={tab.onclick}
                  icon={tab.icon}
                  className={styles.singleTab}
                />
              ))}
            </div>
          </div>
        }
      />

      {loading ? (
        <div className={styles.loader}>
          <Loader />
        </div>
      ) : isModelsCatalogEnabled ? (
        <div className={styles.content}>
          {selectedTab === modelCatalogeTabTypes.TRAINING_JOBS ? (
            <ModelTable />
          ) : (
            <ValidationJobsTable />
          )}
        </div>
      ) : (
        <UnavailableModal
          onClose={() => navigate("/datasets")}
          actionText={"Go back to datasets page"}
        />
      )}
    </>
  );
}
